export const formatCash = (value: number, lang: string = 'en') => {
  if (value > 0) {
    if (value < 1e3) return value.toLocaleString(lang === 'es' ? 'de' : lang)
    if (value >= 1e3 && value < 1e6)
      return (
        <>
          {(+(value / 1e3).toFixed(1)).toLocaleString(lang === 'es' ? 'de' : lang)}
          <span className="m-0 font-montserrat text-xs font-normal">K</span>
        </>
      )
    if (value >= 1e6 && value < 1e9)
      return (
        <>
          {(+(value / 1e6).toFixed(1)).toLocaleString(lang === 'es' ? 'de' : lang)}
          <span className="m-0 font-montserrat text-xs font-normal">M</span>
        </>
      )
    if (value >= 1e9 && value < 1e12)
      return (
        <>
          {(+(value / 1e9).toFixed(1)).toLocaleString(lang === 'es' ? 'de' : lang)}
          <span className="m-0 font-montserrat text-xs font-normal">B</span>
        </>
      )
    if (value >= 1e12)
      return (
        <>
          {(+(value / 1e12).toFixed(1)).toLocaleString(lang === 'es' ? 'de' : lang)}
          <span className="mt-0.5 text-xs font-normal">T</span>
        </>
      )
  }
}

/**
 * Formats currency with proper position based on currency code
 * EUR symbol goes after the number, USD symbol goes before the number
 * @param {number} num - The number to format
 * @param {string} currencyCode - Currency code (EUR, USD, etc.)
 * @param {string} countryCode - Country code for locale formatting (default: 'en-US')
 * @returns {string} Formatted currency string
 */
export const formatCurrencyWithProperPosition = (num: number, currencyCode: string = 'USD', countryCode: string = 'en-US'): string => {
  if (num === null || num === undefined || isNaN(num)) {
    return '-';
  }

  // Format the number without currency symbol
  const formattedNumber = Number(num)?.toLocaleString(countryCode, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  if (currencyCode === 'EUR') {
    // EUR symbol goes after the number
    return `${formattedNumber} €`;
  } else if (currencyCode === 'USD') {
    // USD symbol goes before the number
    return `$ ${formattedNumber}`;
  } else {
    // Fallback to standard formatting for other currencies
    return Number(num).toLocaleString(countryCode, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }
};

// Puntuates number & return
// @param {number} amount
// @param {string} locale
// @returns
//  - puntuated number
export const punctuateNumber = ({ amount, locale }: { amount: number, locale: string }) =>
  Intl.NumberFormat(locale).format(amount);